import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import {Typography} from '@mui/material';
import PatientRowItem from './patientRowItem';
import moment from 'moment';

const SelectedPatientContext = ({ patient, selectedHr, onRefuse }) => {
  const { t } = useTranslation();

  return (
    <>
      <PatientRowItem
        patient={patient}
        onRefReset={onRefuse}
      />

      <Grid container item xs={12} sx={{py: 2, pl: 1}} gap={2}>
        <Typography variant="body2" fontWeight={500}>
          {t("Selected app. hour: ")}
        </Typography>

        <Typography variant="body2">
          {moment(selectedHr).format(window.envConfig.defaultDateTimeFormat)}
        </Typography>

      </Grid>
    </>
  )
}

SelectedPatientContext.propTypes = {
  onRefuse: PropTypes.func.isRequired,
  patient: PropTypes.object.isRequired,
  selectedHr: PropTypes.string.isRequired,
}

export default SelectedPatientContext;
